<div *ngIf="article" class="other-articles d-flex flex-column">
  <h3>{{ 'ARTICLES_MORE_ARTICLES' | translate }} {{ 'IN' | translate }} {{ article.mainCategory }}</h3>

  <div class="row ms-auto me-auto">
    <div *ngFor="let article of latestArticles$ | async" class="col-sm-6 col-md-4">
      <div class="last-stories-item d-flex flex-column">
        <img (click)="showArticle(article)" src="{{ article.images[0].thumb_small }}" class="img-fluid round-img" />
        <div class="article-info">
          <span class="article-info-date"
            >{{ article.publication_date | date: 'MMM d y H:mm' }}
            <app-main-category-btn
              (searchString$)="search($event)"
              mainCategory="{{ article?.mainCategory }}"
            ></app-main-category-btn
          ></span>
        </div>
        <h5 class="article-title" (click)="showArticle(article)">{{ article.title }}</h5>
        <span class="article-info-cat mb-3">ETX Daily Up</span>
      </div>
    </div>
  </div>
</div>
